var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseAccountIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M85 30.517c0 3.85-2.299 7.32-5.825 8.794a9.377 9.377 0 01-10.284-2.064 9.576 9.576 0 01-2.045-10.372C68.306 23.318 71.748 21 75.565 21 80.775 21 85 25.261 85 30.517h0zm-5.824-3.643l-7.225 7.287m0-7.287l7.225 7.287m-4.258 5.919v21.604A2.31 2.31 0 0172.623 64H23.295A2.31 2.31 0 0121 61.684V32.07a2.31 2.31 0 012.295-2.315h42.733m-15.667 7.43H68.3m-5.66 19.277h5.66v-5.708h-5.66v5.708h0zm-28.17-2.787h3.537m3.541 0h3.537m3.541 0h3.537m-24.77 0h3.536"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.297,
    cy: 73.297,
    r: 3,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 85.297 73.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.198,
    cy: 13.198,
    r: 2,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-174 30.198 13.198)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF94CA",
    d: "M6.05 86.44c-.027.02-.068-.033-.089-.06.048-4.039.39-8.085 1.088-12.06.007-.047.034-.068.062-.088a19.19 19.19 0 014.34.006c.267.012.451.257.437.523l-.86 7.29c-.007.047.013.075.061.081 2.085.26 5.051.664 7.136.924.048.006.068.033.061.081l-.787 4.425c-.007.048-.034.068-.082.062-.43-.059-8.346-.991-11.367-1.184z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccountIllustration);
export default __webpack_public_path__ + "static/media/close-account-illustration.24e8642a.svg";
export { ForwardRef as ReactComponent };